import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'
import { Vehicle } from '@/types/vehicle'

export function getVehicles(): Promise<AxiosResponse<Vehicle[]>> {
  return instance.get(`/vehicle`)
}
